import { render, staticRenderFns } from "./snippet-detail.vue?vue&type=template&id=ba2d7e78&scoped=true"
import script from "./snippet-detail.vue?vue&type=script&lang=js"
export * from "./snippet-detail.vue?vue&type=script&lang=js"
import style0 from "./snippet-detail.vue?vue&type=style&index=0&id=ba2d7e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2d7e78",
  null
  
)

export default component.exports